module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAApklEQVRIS+2WwQnCQBBF3+/ETtQeBI+KRXhVrylC9CjYg7ETO/myEDDKsDExBw+7x5kd3uxnmL8iOLb3wC7KZWIHSanu7egzYHsJrICqJ2ALHCVd23UR4Abco25ywObVU0nzAgiVKhJ1TmyRqEj0UsB22UX/sU1nnXMZX6i/9gOg7glJTQ03HNtrYNJAH5JO7QZ+3kVjAhbAZqDpnyVdsp6ckmN+W55rK80ZEz6H+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/screen/shouji.png
// module id = eDcU
// module chunks = 3